import { local } from "store2";

export const isIdentifiedToken = () => {
  return local.get("token")?.authLevel === "identified";
};
